export const MSG_VINCULOS_REMUNERACAO_PERIODO_MENOR_QUE_PERMITIDO = "São válidas para edição somente competências a partir de julho de 1994";
export const MSG_VINCULOS_COMPETENCIAS_PERIODO_INCONSISTENTE = "A referência final deve ser igual ou posterior a referência inicial.";
export const MSG_TAREFA_INCOMPATIVEL = "O serviço selecionado para este requerente é incompatível com o requerimento apresentado em tela. Certifique sua escolha ou ligue 135, de segunda a sábado de 07h às 22h."

export const obterMensagemCampoObrigatorio = (nomeCampo) =>
  `${nomeCampo} deve ser informado(a).`;

export const obterMensagemPeriodoInvalido = (periodoInicio, periodoFim) =>
  `Referência inicial e final devem ficar entre: ${periodoInicio} e ${periodoFim}.`;